import { Spinner } from "../../Spinner/Spinner"

export const Transcoding = () => {
    return (
        <div className="flex flex-row gap-x-4 items-center justify-center  w-full h-full">
            <Spinner />
            <p>Media Transcoding...</p>
        </div>
    )
}